const NUM_MAX = 99999999; // 数量类指标最大值 - 8位数
const YUAN_MAX = 99999999999; // 金额类指标最大值 - 11位数
// 年度规划类型常量
export const INDICATOR_TYPES = {
  REGION: 'REGION',
  INDUSTRY: 'INDUSTRY'
};

// 年度规划列表审批状态选项
export const APPROVAL_STATUS_OPTIONS = [
  { label: '审批中', value: 1 },
  { label: '已完成', value: 2 },
  { label: '驳回', value: 3 },
  { label: '召回', value: 4 },
  { label: '废弃', value: 5 }
];

// 年度规划申请表格配置
// 指标分组配置：描述各 KPI 所属分类及汇总方式
export const INDICATOR_GROUPS = [
  {
    category: '数量',
    weightKey: 'weightQuantity',
    rows: [
      {
        key: 'offlineEvents',
        label: '线下活动场次',
        calc: 'sum',
        decimals: 0,
        isInteger: true,
        types: [INDICATOR_TYPES.REGION],
        typeOrder: {
          [INDICATOR_TYPES.REGION]: 0
        },
        max: NUM_MAX
      },
      {
        key: 'hqEvents',
        label: '总部大活动场次',
        calc: 'sum',
        decimals: 0,
        isInteger: true,
        types: [INDICATOR_TYPES.INDUSTRY],
        typeOrder: {
          [INDICATOR_TYPES.INDUSTRY]: 0
        },
        max: NUM_MAX
      },
      {
        key: 'templateEvents',
        label: '模板活动规划场次（全国）',
        calc: 'sum',
        decimals: 0,
        isInteger: true,
        types: [INDICATOR_TYPES.INDUSTRY],
        typeOrder: {
          [INDICATOR_TYPES.INDUSTRY]: 1
        },
        max: NUM_MAX
      },
      {
        key: 'livestreamEvents',
        label: '直播场次',
        calc: 'sum',
        decimals: 0,
        isInteger: true,
        types: [INDICATOR_TYPES.REGION, INDICATOR_TYPES.INDUSTRY],
        typeOrder: {
          [INDICATOR_TYPES.REGION]: 1,
          [INDICATOR_TYPES.INDUSTRY]: 2
        },
        max: NUM_MAX
      },
      { key: 'contents', label: '内容营销数量', calc: 'sum', decimals: 0, isInteger: true, max: NUM_MAX }
    ]
  },
  {
    category: '覆盖',
    weightKey: 'weightCoverage',
    rows: [
      { key: 'coverage', label: '客户/渠道覆盖单位数', calc: 'sum', decimals: 0, isInteger: true, max: NUM_MAX }
    ]
  },
  {
    category: '线索',
    weightKey: 'weightLeads',
    rows: [
      { key: 'leadsNew', label: '新建业务机会个数', calc: 'sum', decimals: 0, isInteger: true, max: NUM_MAX },
      { key: 'projects', label: '推动项目进阶数', calc: 'sum', decimals: 0, isInteger: true, max: NUM_MAX },
      { key: 'amount', label: '推动金额（元）', calc: 'sum', decimals: 2, isInteger: false, max: YUAN_MAX }
    ]
  },
  {
    category: '成本',
    weightKey: 'weightCost',
    rows: [
      { key: 'cpml', label: '单个单位覆盖成本（元）（CPML）', calc: 'average', decimals: 2, isInteger: false, max: YUAN_MAX },
      { key: 'cpsql', label: '单个新建业务机会成本（元）（CPSQL）', calc: 'average', decimals: 2, isInteger: false, max: YUAN_MAX }
    ]
  }
];

// 季度列配置：可通过 availableQuarters 控制展示区间
export const QUARTER_PERIODS = [
  { key: 'q1', label: 'Q1' },
  { key: 'q2', label: 'Q2' },
  { key: 'q3', label: 'Q3' },
  { key: 'q4', label: 'Q4' }
];
